
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzePunteggiGrid extends Serenity.EntityGrid<ProdottiEsperienzePunteggiRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzePunteggiColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzePunteggiDialog; }
        protected getIdProperty() { return ProdottiEsperienzePunteggiRow.idProperty; }
        protected getInsertPermission() { return ProdottiEsperienzePunteggiRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiEsperienzePunteggiRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzePunteggiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}